/** Résolution GA4 — garder aligné avec `config/ga.cjs`. L'ID jeu-151 n'est jamais hardcodé. */

function normalizeHost(hostname: string): string {
  return hostname.replace(/\.$/, "").toLowerCase();
}

export function isJeu151Host(hostname: string): boolean {
  const host = normalizeHost(hostname);
  return host === "jeu-151.com" || host.endsWith(".jeu-151.com");
}

export function isDevHost(hostname: string): boolean {
  const host = normalizeHost(hostname);
  return (
    host === "" ||
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "[::1]" ||
    host.endsWith(".local")
  );
}

export function resolveGaMeasurementId(options: {
  hostname?: string;
  domainSet?: string;
  envId?: string;
  fallbackId?: string;
}): string {
  const hostname = options.hostname || "";
  const domainSet = options.domainSet || "";
  const envId = (options.envId || "").trim();
  const fallbackId = (options.fallbackId || "").trim();

  if (!isDevHost(hostname)) {
    return isJeu151Host(hostname) ? envId : fallbackId;
  }
  if (domainSet === "jeu151") {
    return envId;
  }
  if (domainSet === "djamma") {
    return fallbackId;
  }
  return envId || fallbackId;
}
